function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagnifyingglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.875 2.2a8.675 8.675 0 105.542 15.35l4.017 4.016a.8.8 0 101.131-1.132l-4.016-4.016A8.675 8.675 0 0010.875 2.2zM3.8 10.875a7.075 7.075 0 1114.15 0 7.075 7.075 0 01-14.15 0z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgMagnifyingglass;